import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Input from '../shared/inputs/Input';
import Http from '../shared/http';

export default class AddGroup extends Component {

  static defaultProps = {
    name: '',
    clients: [],
    selectedClients: '',
    isEdit: false,
    groupId: null
  }

  static propTypes = {
    name: PropTypes.string,
    clients: PropTypes.array,
    selectedClients: PropTypes.string,
    isEdit: PropTypes.bool,
    groupId: PropTypes.number,
    tenant: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      selectedClients: this.props.selectedClients,
      isLoading: false
    };
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    if (prevProps.selectedClients != this.props.selectedClients) {
      this.setState({
        name: this.props.name,
        selectedClients: this.props.selectedClients
      });
    }
  }

  handleSelectChange = (selectedClients) => {
    this.setState({ selectedClients });
  }

  submitGroup = (e) => {
    e.preventDefault();
    let params = {
      group: {
        name: this.state.name,
        client_ids: this.state.selectedClients && this.state.selectedClients.map((client) => client.id)
      }
    };

    let httpMethod = "POST";
    let httpUrl = `/wealth_managers/groups`;
    if (this.props.isEdit) {
      httpMethod = "PUT";
      httpUrl = `/wealth_managers/groups/${this.props.groupId}`;
    }

    Http.request(httpUrl, httpMethod, JSON.stringify(params)).then((response) => {
      window.location = window.location.href;
    });

    this.setState({ isLoading: true })
  }

  render() {
    return (
      <div className='group-wrapper'>
        <fieldset className="form-inputs" style={{ marginBottom: '1rem' }}>
          <Input name="group[name]"
            onChange={(value) => { this.setState({ name: value }) }}
            label="Group name"
            value={this.state.name}
            isRequired={true}
            isValidCallback={(isValid) => { }}
            validations={['presence']}>
          </Input>
          <div className="form-input form-input--has-padding">
            <label className="form-control">
              <div className="form-control__label">
                Group clients
              </div>
              <div className="form-control__input">
                <Select
                  isMulti
                  isSearchable
                  hideSelectedOptions
                  getOptionValue={(option) => option['id']}
                  getOptionLabel={(option) => option['name']}
                  placeholder=""
                  name="group[clients]"
                  maxMenuHeight={100}
                  onChange={this.handleSelectChange}
                  value={this.state.selectedClients}
                  options={this.props.clients}
                />
              </div>
            </label>
          </div>
        </fieldset>

        <div className="form__actions form__actions--multiple form__actions--padding-half">
          <button className="button button--secondary" data-close="">Cancel</button>
          <button type="submit" className="button" onClick={this.submitGroup} disabled={this.state.isLoading}>
            {this.state.isLoading ? 'Loading...' : 'Save group'}
          </button>
        </div>
      </div>
    );
  }
}
